import { AnalyticsBrowser } from '@segment/analytics-next';
import { signInCheck } from '../../../components/common/CheckUserStatus';
import { readCookie, createCookie, readCohortValueCookie } from '../../../components/common/Cookie';
import endpoints from '../../../modules/ajio-util/endpoints';
import {
  getSegmentTrackingEnabledFlag,
  getAffiliateFeatureConfig,
  getCreatorProgramConfig,
  getAffiliateAttributionWindow
} from '../../../refresh/selectors/featureFlagsSelector';
import { getAffiliateCookie, setAffiliateCookie } from '../../../utils/affiliateUtils';
const CryptoJS = require('crypto-js');

const segmentTrackingEnabled = getSegmentTrackingEnabledFlag(window?.__PRELOADED_STATE__?.flags);
const isAffiliateFeatureEnabled = getAffiliateFeatureConfig(window?.__PRELOADED_STATE__);
const isCreatorFeatureEnabled = getCreatorProgramConfig(window?.__PRELOADED_STATE__);
const affiliateAttributionWindow = getAffiliateAttributionWindow(window?.__PRELOADED_STATE__);
const segment_api_write_key = endpoints.getProperties('segment_api_write_key');
const cleverTapId = endpoints.getProperties('cleverTapID');
const AFFILIATE_KEYS = [
  'attributed_affiliate_name',
  'attributed_affiliate_id',
  'attributed_affiliate_campaign_id',
  'attributed_affiliate_click_id',
  'attributed_affiliate_sub_id',
  'attributed_affiliate_additional_publisher_info',
  'attributed_affiliate_campaign_name',
  'attributed_affiliate_campaign_medium'
];
export const analytics = new AnalyticsBrowser();

console.log('segmentTrackingEnabled', segmentTrackingEnabled);
if (segmentTrackingEnabled == 'ON') {
  // Set affiliate/creator cookie before identity call so traits include attribution data
  const affiliateConfigForCookie = {
    ...(isAffiliateFeatureEnabled || {}),
    attributionWindow: affiliateAttributionWindow
  };
  if (isCreatorFeatureEnabled?.masterFlag) {
    setAffiliateCookie(affiliateConfigForCookie, isCreatorFeatureEnabled);
  } else {
    setAffiliateCookie(affiliateConfigForCookie, {});
  }
  analytics.load({ writeKey: segment_api_write_key });
  setUserDetails();
}

function setUserDetails() {
  setTimeout(async () => {
    const user = await analytics.user();
    createCookie('segment_user_id', user.id());
    createCookie('segment_device_id', user.anonymousId());
  }, 10);
}

function sha256Hex(message) {
  if (!message) return '';

  const hash = CryptoJS.SHA256(message);
  return hash.toString(CryptoJS.enc.Hex);
}

export function segmentTrackUser(profileResponse, otherDetails) {
  if (segmentTrackingEnabled == 'ON') {
    if (profileResponse) {
      const customerType = readCookie('customerType') || 'new';
      const isNew = customerType?.toLowerCase() === 'new';
      const pincode = readCookie('PC');
      const storeName = window?.__PRELOADED_STATE__?.metaData?.name || '';
      const city = (readCookie('CT') || '').toLowerCase();
      const region = (readCookie('ZN') || '').toLowerCase();
      let funtionTriggered = 0;
      let hasIdentityEventFired = false;

      const hashDigest = sha256Hex(profileResponse.customerUuid);

      const triggerIdentityEvent = () => {
        if (hasIdentityEventFired) return;

        if (
          (!readCohortValueCookie('userCohortValues', storeName, 'cms') ||
            !readCookie('PC') ||
            !readCookie('CT') ||
            !readCookie('ZN') ||
            !readCookie("customerType")) &&
          funtionTriggered <= 9
        ) {
          setTimeout(() => {
            triggerIdentityEvent();
            funtionTriggered += 1;
          }, 1000);

          return;
        }
        const traits = {
          customer_pk: sha256Hex(profileResponse.pk),
          name: sha256Hex(profileResponse.name?.toLowerCase()),
          email: sha256Hex(profileResponse.uid?.toLowerCase()),
          mobileNumber: sha256Hex(profileResponse.mobileNumber),
          cleverTap_Id: cleverTapId || '',
          new_repeat_customer_flag: isNew,
          new_repeat_customer_type: isNew ? 'New' : 'Existing',
          new_repeat_visitor: isNew ? 'new' : 'repeat',
          ...(pincode && { pincode }),
          ...(readCohortValueCookie('userCohortValues', storeName, 'cms') && {
            customer_cohort: readCohortValueCookie('userCohortValues', storeName, 'cms')
          }),
          ...(city && { city }),
          ...(region && { region })
        };
        const affiliateData = getAffiliateCookie();
        // 🔥 ALWAYS reset affiliate traits (even if no affiliateData present)
        AFFILIATE_KEYS.forEach(key => {
          traits[key] = 'NA';
        });

        // ✅ Add fresh affiliate/creator data only if available + matching channel enabled
        const medium = affiliateData?.attributed_affiliate_campaign_medium;
        const isChannelEnabled =
          medium === 'creator'
            ? isCreatorFeatureEnabled?.masterFlag
            : true;
        if (isChannelEnabled && affiliateData && Object.keys(affiliateData).length > 0) {
          Object.assign(traits, affiliateData);
        }
        analytics?.identify(hashDigest, traits);

        setUserDetails();
        hasIdentityEventFired = true;
      };

      triggerIdentityEvent();
    }
  }
}

function getCustomerUUID() {
  const userUUID = readCookie('CI');
  return userUUID ? decodeURIComponent(userUUID) : '';
}

//check on load
if (signInCheck() && segmentTrackingEnabled == 'ON') {
  const customerUUI = getCustomerUUID();
  const customerType = readCookie('customerType') || 'new';
  const emailId = readCookie('U');
  const customer_pk = readCookie('PK');
  const mobileNumber = readCookie('MN');
  const name = readCookie('un');
  const isNew = customerType?.toLowerCase() === 'new';
  const pincode = readCookie('PC');
  const storeName = window?.__PRELOADED_STATE__?.metaData?.name || '';
  const city = (readCookie('CT') || '').toLowerCase();
  const region = (readCookie('ZN') || '').toLowerCase();

  const hashDigest = sha256Hex(customerUUI);
  let funtionTriggered = 0;
  let hasIdentityEventFired = false;

  const triggerIdentityEvent = () => {
    if (hasIdentityEventFired) return;

    if (
      (!readCohortValueCookie('userCohortValues', storeName, 'cms') ||
        !readCookie('PC') ||
        !readCookie('CT') ||
        !readCookie('ZN') ||
        !readCookie("customerType")) &&
      funtionTriggered <= 9
    ) {
      setTimeout(() => {
        triggerIdentityEvent();
        funtionTriggered += 1;
      }, 1000);

      return;
    }
    const traits = {
      customer_pk: sha256Hex(customer_pk),
      name: sha256Hex(name?.toLowerCase()),
      email: sha256Hex(emailId?.toLowerCase()),
      mobileNumber: sha256Hex(mobileNumber),
      cleverTap_Id: cleverTapId || '',
      new_repeat_customer_flag: isNew,
      new_repeat_customer_type: isNew ? 'New' : 'Existing',
      new_repeat_visitor: isNew ? 'new' : 'repeat',
      ...(pincode && { pincode }),
      ...(readCohortValueCookie('userCohortValues', storeName, 'cms') && {
        customer_cohort: readCohortValueCookie('userCohortValues', storeName, 'cms')
      }),
      ...(city && { city }),
      ...(region && { region })
    };
    const affiliateData = getAffiliateCookie();
    // 🔥 ALWAYS reset affiliate traits (even if no affiliateData present)
    AFFILIATE_KEYS.forEach(key => {
      traits[key] = 'NA';
    });

    // ✅ Add fresh affiliate/creator data only if available + matching channel enabled
    const medium = affiliateData?.attributed_affiliate_campaign_medium;
    const isChannelEnabled =
      medium === 'creator'
        ? isCreatorFeatureEnabled?.masterFlag
        : true;
    if (isChannelEnabled && affiliateData && Object.keys(affiliateData).length > 0) {
      Object.assign(traits, affiliateData);
    }
    analytics?.identify(hashDigest, traits);

    setUserDetails();
    hasIdentityEventFired = true;
  };

  triggerIdentityEvent();
} else if (segmentTrackingEnabled == 'ON') {
  setTimeout(() => {
    const traits = {
      customer_pk: sha256Hex(''),
      name: sha256Hex(''),
      email: sha256Hex(''),
      mobileNumber: sha256Hex(''),
      cleverTap_Id: cleverTapId || '',
      new_repeat_customer_flag: true,
      new_repeat_customer_type: 'Guest',
      new_repeat_visitor: 'new'
    };
    const affiliateData = getAffiliateCookie();
    // 🔥 ALWAYS reset affiliate traits (even if no affiliateData present)
    AFFILIATE_KEYS.forEach(key => {
      traits[key] = 'NA';
    });
    // ✅ Add fresh affiliate/creator data only if available + matching channel enabled
    const medium = affiliateData?.attributed_affiliate_campaign_medium;
    const isChannelEnabled =
      medium === 'creator'
        ? isCreatorFeatureEnabled?.masterFlag
        : true;
    if (isChannelEnabled && affiliateData && Object.keys(affiliateData).length > 0) {
      Object.assign(traits, affiliateData);
    }
    analytics?.identify(traits);
  }, 1000);

  setUserDetails();
}
